import React, { useContext } from 'react'
import '../index.scss'
import { SelectOption } from '@Components/Selectors/Select'
import {
    writerFirstNameInvalidCheck,
    writerLastNameInvalidCheck,
    writerRoleInvalidCheck,
} from '@App/helpers/work-entities/fields-validators'
import { stringEscapeNewlines } from '@App/helpers/string-escape-newlines'
import { StoresContext } from '@App/contexts'
import { IPIValidator } from '@App/helpers/validate'
import clsx from 'clsx'

import { WriterModel } from '@Entities/work/writer-model'

interface WriterCardFullProps {
    data: WriterModel
    addFunction?(): void
    removeFunction?(removingWriter: WriterModel): void
}

const WriterCardFull = (props: WriterCardFullProps) => {
    const { libStore } = useContext(StoresContext)

    const { data, addFunction, removeFunction } = props

    const { firstName, lastName, ipiNumber, roleCode } = data
    const roleOptions = libStore.writerRoles

    const getRole = (): string => {
        if (!roleCode) {
            return ''
        }
        const writerRole = roleOptions.find((role: SelectOption) => +role.id === roleCode)
        if (writerRole && writerRole.label) {
            return writerRole.label
        }
        return ''
    }

    const displayRole = getRole()

    return (
        <div className="writer-card">
            <div className="head">
                <p className="bold">
                    <span className={clsx(writerFirstNameInvalidCheck(firstName) && 'red-text bold')}>
                        {firstName ? stringEscapeNewlines(firstName) : '___'}
                    </span>
                    <span className={clsx(writerLastNameInvalidCheck(lastName) && 'red-text bold')}>
                        {lastName ? stringEscapeNewlines(lastName) : '___'}
                    </span>
                </p>
                <div className="controls">
                    {addFunction ? <span className="small-2 medium">Add</span> : null}
                    {removeFunction ? (
                        <span className="small-2 medium" onClick={() => removeFunction(data)}>
                            Remove
                        </span>
                    ) : null}
                </div>
            </div>
            <div className="content">
                <p className="small">
                    <span className={clsx(!IPIValidator(ipiNumber, false) && 'red-text bold')}>IPI: </span>
                    <strong>{data.ipiNumber}</strong>
                </p>
                <p className="small">
                    <span className={clsx(writerRoleInvalidCheck(roleCode, roleOptions) && 'red-text bold')}>
                        Writer role:{' '}
                    </span>
                    <strong>{!!displayRole && displayRole}</strong>
                </p>
            </div>
        </div>
    )
}

export default WriterCardFull
